module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('div', {
    attrs: {
      "transition": "fade-transition"
    }
  }, [_c('v-card', {
    attrs: {
      "tile": "",
      "transition": "fade-transition"
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "feedbackform",
    attrs: {
      "id": "content-story-form",
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-center": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "content xs12 pt-2 md12"
  }, [_c('div', {
    staticClass: "storyboard-page-toolbar"
  }, [(_vm.isCreateMode) ? _c('h2', {
    staticClass: "form-title mb-0"
  }, [_vm._v("Content Storyboard Flow")]) : _vm._e(), _vm._v(" "), (_vm.isInternalView) ? _c('v-btn', {
    staticClass: "version-history-toggle",
    attrs: {
      "color": "secondary",
      "text": "",
      "aria-expanded": _vm.showVersionHistory ? 'true' : 'false'
    },
    on: {
      "click": function($event) {
        _vm.showVersionHistory = !_vm.showVersionHistory
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-history")]), _vm._v("\n                  " + _vm._s(_vm.showVersionHistory ? 'Hide history' : 'Version history') + "\n                  "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v(_vm._s(_vm.showVersionHistory ? 'mdi-chevron-left' : 'mdi-chevron-right'))])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "storyboard-workspace"
  }, [_c('v-slide-x-transition', [(_vm.isInternalView && _vm.showVersionHistory) ? _c('aside', {
    staticClass: "version-history-column"
  }, [_c('v-card', {
    staticClass: "version-history-card"
  }, [_c('v-card-title', {
    staticClass: "version-history-title"
  }, [_vm._v("\n                        Version History\n                      ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "version-history-list"
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.contentScriptVersions), function(hpost, i) {
    return [_c('v-list-item', {
      key: hpost.id + i,
      class: {
        'version-history-item--selected': hpost.id === _vm.creatorConceptData.id
      },
      on: {
        "click": function($event) {
          return _vm.switchVersion(hpost)
        }
      }
    }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v("\n                                " + _vm._s(hpost.versionNo) + " " + _vm._s(hpost.isMain ? "(Active)" : '') + "\n                              ")]), _vm._v(" "), _c('v-list-item-title', [_vm._v("\n                                " + _vm._s(hpost.isMain ? ("" + (_vm.formatDate(hpost.createdAt))) : _vm.formatDate(hpost.createdAt)) + "\n                              ")])], 1), _vm._v(" "), (hpost.id === _vm.creatorConceptData.id) ? _c('v-list-item-action', [_c('v-icon', {
      attrs: {
        "color": "green"
      }
    }, [_vm._v("check_circle")])], 1) : _vm._e(), _vm._v(" "), (hpost.id !== _vm.creatorConceptData.id && hpost.id === _vm.mainData.id) ? _c('v-list-item-action', [_c('v-icon', {
      attrs: {
        "color": "green"
      }
    }, [_vm._v("check_circle_outline")])], 1) : _vm._e()], 1)]
  })], 2)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "version-history-actions"
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.setMainVersion(_vm.creatorConceptData.id)
      }
    }
  }, [_vm._v("\n                            Change to this version\n                        ")])], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "storyboard-editor-column"
  }, [(_vm.creatorConceptData.approved) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "success",
      "dense": ""
    }
  }, [_vm._v("\n                        Approved\n                      ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-row', {
    staticClass: "mt-0"
  }, [_c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    staticClass: "px-5 pt-0 clearfix",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    staticClass: "col-xs-12 col-md-12 pb-0"
  }, [_c('div', {
    staticClass: "storyboard-header"
  }, [_c('div', {
    staticClass: "storyboard-meta"
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_c('span', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v("Campaign Name")]), _vm._v(": \n                                "), _c('span', {
    staticClass: "h5 font-weight-bold mb-2",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.creatorConceptData.campaignName))])]), _vm._v(" "), _c('div', {
    staticClass: "mb-2"
  }, [_c('span', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v("Creator Handle")]), _vm._v(": \n                                "), _c('span', {
    staticClass: "h5 font-weight-bold mb-2",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.creatorConceptData.creatorHandle))])])]), _vm._v(" "), (_vm.isCreateMode) ? _c('div', {
    staticClass: "avatar-logo"
  }, [_c('a', {
    attrs: {
      "href": "https://www.getkobe.com",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logoDataUrl,
      "alt": "KOBE Logo"
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mb-2"
  }, [_c('span', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v("Draft Submission Date")]), _vm._v(": \n                            "), _c('span', {
    staticClass: "h5 font-weight-bold mb-2",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.creatorConceptData.submissionDate))])]), _vm._v(" "), _c('div', {
    staticClass: "mb-2"
  }, [_c('span', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v("Deliverable Details")]), _vm._v(": \n                            "), _c('span', {
    staticClass: "h5 font-weight-bold mb-2",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.creatorConceptData.deliverableLists))])])]), _vm._v(" "), _vm._l((_vm.creatorConceptData.deliverables), function(deliItem, deliIndex) {
    return _c('div', {
      key: deliIndex
    }, [_c('v-col', {
      staticClass: "col-xs-12 col-md-12 pt-1 pb-1",
      staticStyle: {
        "background": "rgb(244, 244, 244)"
      }
    }, [_c('div', {
      staticClass: "d-flex flex-row",
      staticStyle: {
        "justify-content": "space-between"
      }
    }, [_c('span', {
      staticClass: "h4 font-weight-bold mb-2 pt-0 pb-0"
    }, [_vm._v(_vm._s(deliItem.title))]), _vm._v(" "), _c('div', [_c('v-menu', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (deliItem.showChat),
        expression: "deliItem.showChat"
      }],
      attrs: {
        "close-on-content-click": false,
        "bottom": "",
        "offset-x": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;
          var attrs = ref.attrs;

          return [(_vm.isCommentSection) ? _c('v-badge', {
            staticStyle: {
              "margin-left": "-10px"
            },
            attrs: {
              "value": deliItem.comments ? deliItem.comments.length : '',
              "content": deliItem.comments ? deliItem.comments.length : '',
              "color": "black",
              "overlap": ""
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.showChatBox(deliIndex)
              }
            }
          }, [(_vm.isCommentSection) ? _c('v-btn', _vm._g(_vm._b({
            staticStyle: {
              "padding": "0",
              "min-width": "34px"
            },
            attrs: {
              "text": ""
            },
            on: {
              "click": function($event) {
                return _vm.showChatBox(deliIndex)
              }
            }
          }, 'v-btn', attrs, false), on), [_c('v-icon', {
            attrs: {
              "color": "secondary"
            }
          }, [_vm._v("chat")])], 1) : _vm._e()], 1) : _vm._e()]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-card', {
      staticStyle: {
        "text-align": "left"
      },
      attrs: {
        "max-width": "300"
      }
    }, [_c('v-card-text', {
      staticStyle: {
        "background-color": "#fff",
        "padding": "0"
      }
    }, [_c('chatbox', {
      attrs: {
        "messages": deliItem.comments,
        "title": ""
      },
      on: {
        "sendMessage": function($event) {
          return _vm.sendComment(deliItem.id, $event)
        }
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (deliItem.showComment),
        expression: "deliItem.showComment"
      }],
      staticClass: "putComment"
    }, [_c('span', [_vm._v("Put your comments here")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.closePutComment(deliIndex)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": "",
        "color": "white"
      }
    }, [_vm._v("mdi-close-circle")])], 1)])], 1)])]), _vm._v(" "), (deliItem.type !== 'igCarousel' && deliItem.type !== 'linkedIn') ? _c('div', [_c('v-col', {
      staticClass: "col-xs-12 col-md-12"
    }, [_c('div', {
      staticClass: "d-flex row col mb-2"
    }, [_c('span', {
      staticClass: "h4 font-weight-bold mb-2 col-2",
      staticStyle: {
        "min-width": "160px"
      }
    }, [_vm._v("Concept:")]), _vm._v(" "), _c('v-textarea', {
      attrs: {
        "disabled": _vm.isClient,
        "outlined": "",
        "required": "",
        "dense": "",
        "hide-details": "",
        "rows": "5"
      },
      model: {
        value: (deliItem.concept),
        callback: function($$v) {
          _vm.$set(deliItem, "concept", $$v)
        },
        expression: "deliItem.concept"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "d-flex row col mb-2"
    }, [_c('span', {
      staticClass: "h4 font-weight-bold mb-2 col-2",
      staticStyle: {
        "min-width": "160px"
      }
    }, [_vm._v("Reason for concept:")]), _vm._v(" "), _c('v-textarea', {
      attrs: {
        "disabled": _vm.isClient,
        "outlined": "",
        "required": "",
        "dense": "",
        "hide-details": "",
        "rows": "5"
      },
      model: {
        value: (deliItem.reasonConcept),
        callback: function($$v) {
          _vm.$set(deliItem, "reasonConcept", $$v)
        },
        expression: "deliItem.reasonConcept"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "d-flex row col mb-2"
    }, [_c('span', {
      staticClass: "h4 font-weight-bold mb-2 col-2",
      staticStyle: {
        "min-width": "160px"
      }
    }, [_vm._v("Music choice:")]), _vm._v(" "), _c('v-textarea', {
      attrs: {
        "disabled": _vm.isClient,
        "outlined": "",
        "required": "",
        "dense": "",
        "hide-details": "",
        "rows": "5"
      },
      model: {
        value: (deliItem.musicChoice),
        callback: function($$v) {
          _vm.$set(deliItem, "musicChoice", $$v)
        },
        expression: "deliItem.musicChoice"
      }
    })], 1)]), _vm._v(" "), _vm._l((deliItem.boxes), function(boxItem, boxIdx) {
      return _c('v-col', {
        key: boxIdx,
        staticClass: "col-xs-12 col-md-12 d-flex flex-row"
      }, [_c('v-flex', {
        staticClass: "xs12"
      }, [_c('table', {
        staticClass: "content-script-table",
        staticStyle: {
          "border": "none"
        },
        attrs: {
          "dense": ""
        }
      }, [_c('thead', [_c('tr', [_c('th', {
        staticClass: "text-left",
        attrs: {
          "width": "40%"
        }
      }, [_vm._v("\n                                          Descriptions of scenes/ footage\n                                        ")]), _vm._v(" "), _c('th', {
        staticClass: "text-left",
        attrs: {
          "width": "40%"
        }
      }, [_vm._v("\n                                          Include text overlays / voiceover script in each scene\n                                        ")]), _vm._v(" "), _c('th', {
        staticClass: "text-left",
        attrs: {
          "width": "40%"
        }
      }, [_vm._v("\n                                          Reference links/images\n                                        ")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('div', {
        staticClass: "d-flex flex-row align-center justify-space-between mb-1"
      }, [_c('span', {
        staticClass: "tbl-inner-title"
      }, [_vm._v("INTRO: (can be hook/ theme/ title of your video)")]), _vm._v(" "), _c('div', {
        staticClass: "editor-header-actions"
      }, [(_vm.isNotClient) ? _c('editor-format-info', {
        attrs: {
          "format": _vm.storyboardPlaceholders.scenesInfo
        }
      }) : _vm._e(), _vm._v(" "), _c('v-menu', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (boxItem.showChat),
          expression: "boxItem.showChat"
        }],
        attrs: {
          "close-on-content-click": false,
          "bottom": "",
          "offset-x": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;
            var attrs = ref.attrs;

            return [(_vm.isCommentSection) ? _c('v-badge', {
              staticStyle: {
                "margin-left": "-10px"
              },
              attrs: {
                "value": boxItem.introComments ? boxItem.introComments.length : '',
                "content": boxItem.introComments ? boxItem.introComments.length : '',
                "color": "black",
                "overlap": ""
              },
              on: {
                "click": function($event) {
                  $event.stopPropagation();
                  return _vm.showChatBox(deliIndex, boxIdx)
                }
              }
            }, [(_vm.isCommentSection) ? _c('v-btn', _vm._g(_vm._b({
              staticStyle: {
                "padding": "0",
                "min-width": "34px"
              },
              attrs: {
                "text": ""
              },
              on: {
                "click": function($event) {
                  return _vm.showChatBox(deliIndex, boxIdx)
                }
              }
            }, 'v-btn', attrs, false), on), [_c('v-icon', {
              attrs: {
                "color": "secondary"
              }
            }, [_vm._v("chat")])], 1) : _vm._e()], 1) : _vm._e()]
          }
        }], null, true)
      }, [_vm._v(" "), _c('v-card', {
        staticStyle: {
          "text-align": "left"
        },
        attrs: {
          "max-width": "300"
        }
      }, [_c('v-card-text', {
        staticStyle: {
          "background-color": "#fff",
          "padding": "0"
        }
      }, [_c('chatbox', {
        attrs: {
          "messages": boxItem.introComments,
          "title": ""
        },
        on: {
          "sendMessage": function($event) {
            return _vm.sendComment(boxItem.id, $event, 'introComments')
          }
        }
      })], 1)], 1)], 1)], 1)]), _vm._v(" "), (_vm.isNotClient) ? _c('sun-editor', {
        attrs: {
          "button-list": _vm.storyboardToolbar,
          "placeholder": _vm.storyboardPlaceholders.scenesInfo,
          "width": "100%",
          "height": "150"
        },
        model: {
          value: (boxItem.scenesInfo),
          callback: function($$v) {
            _vm.$set(boxItem, "scenesInfo", $$v)
          },
          expression: "boxItem.scenesInfo"
        }
      }) : _vm._e(), _vm._v(" "), (_vm.isClient) ? _c('p', {
        staticClass: "cp",
        staticStyle: {
          "min-height": "150px",
          "max-height": "150px",
          "overflow-y": "auto"
        },
        domProps: {
          "innerHTML": _vm._s(_vm.renderHTML(boxItem.scenesInfo))
        }
      }) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('div', {
        staticClass: "text-right mb-1",
        staticStyle: {
          "min-height": "18px"
        }
      }, [_c('div', {
        staticClass: "editor-header-actions"
      }, [(_vm.isNotClient) ? _c('editor-format-info', {
        attrs: {
          "format": _vm.storyboardPlaceholders.briefText
        }
      }) : _vm._e(), _vm._v(" "), _c('v-menu', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (boxItem.showChatTwo),
          expression: "boxItem.showChatTwo"
        }],
        attrs: {
          "close-on-content-click": false,
          "bottom": "",
          "offset-x": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;
            var attrs = ref.attrs;

            return [(_vm.isCommentSection) ? _c('v-badge', {
              staticStyle: {
                "margin-left": "-10px"
              },
              attrs: {
                "value": boxItem.introCommentsTwo ? boxItem.introCommentsTwo.length : '',
                "content": boxItem.introCommentsTwo ? boxItem.introCommentsTwo.length : '',
                "color": "black",
                "overlap": ""
              },
              on: {
                "click": function($event) {
                  $event.stopPropagation();
                  return _vm.showChatBoxTwo(deliIndex, boxIdx)
                }
              }
            }, [(_vm.isCommentSection) ? _c('v-btn', _vm._g(_vm._b({
              staticStyle: {
                "padding": "0",
                "min-width": "34px"
              },
              attrs: {
                "text": ""
              },
              on: {
                "click": function($event) {
                  return _vm.showChatBoxTwo(deliIndex, boxIdx)
                }
              }
            }, 'v-btn', attrs, false), on), [_c('v-icon', {
              attrs: {
                "color": "secondary"
              }
            }, [_vm._v("chat")])], 1) : _vm._e()], 1) : _vm._e()]
          }
        }], null, true)
      }, [_vm._v(" "), _c('v-card', {
        staticStyle: {
          "text-align": "left"
        },
        attrs: {
          "max-width": "300"
        }
      }, [_c('v-card-text', {
        staticStyle: {
          "background-color": "#fff",
          "padding": "0"
        }
      }, [_c('chatbox', {
        attrs: {
          "messages": boxItem.introCommentsTwo,
          "title": ""
        },
        on: {
          "sendMessage": function($event) {
            return _vm.sendCommentTwo(boxItem.id, $event, 'introCommentsTwo')
          }
        }
      })], 1)], 1)], 1)], 1)]), _vm._v(" "), (_vm.isNotClient) ? _c('sun-editor', {
        attrs: {
          "button-list": _vm.storyboardToolbar,
          "placeholder": _vm.storyboardPlaceholders.briefText,
          "width": "100%",
          "height": "150"
        },
        model: {
          value: (boxItem.briefText),
          callback: function($$v) {
            _vm.$set(boxItem, "briefText", $$v)
          },
          expression: "boxItem.briefText"
        }
      }) : _vm._e(), _vm._v(" "), (_vm.isClient) ? _c('div', {
        staticClass: "cp",
        staticStyle: {
          "min-height": "150px",
          "max-height": "150px",
          "overflow-y": "auto",
          "margin-top": "5px"
        },
        domProps: {
          "innerHTML": _vm._s(_vm.renderHTML(boxItem.briefText))
        }
      }) : _vm._e()], 1), _vm._v(" "), _c('td', {
        staticClass: "reference-cell",
        attrs: {
          "rowspan": "3"
        }
      }, [_c('div', {
        staticClass: "reference-upload-list"
      }, [_vm._l((boxItem.images), function(item, imgIdx) {
        return _c('div', {
          key: imgIdx,
          staticClass: "reference-upload-card"
        }, [_c('div', {
          staticClass: "reference-upload-header"
        }, [_c('span', {
          staticClass: "reference-upload-title"
        }, [_vm._v("Reference " + _vm._s(imgIdx + 1))]), _vm._v(" "), (_vm.isNotClient) ? _c('v-btn', {
          staticClass: "reference-remove-btn",
          attrs: {
            "icon": "",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteImage(deliIndex, boxIdx, imgIdx)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "red",
            "small": ""
          }
        }, [_vm._v("mdi-close-circle")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.isNotClient) ? _c('v-btn-toggle', {
          staticClass: "reference-type-toggle",
          attrs: {
            "mandatory": "",
            "dense": ""
          },
          model: {
            value: (item.refLinkType),
            callback: function($$v) {
              _vm.$set(item, "refLinkType", $$v)
            },
            expression: "item.refLinkType"
          }
        }, [_c('v-btn', {
          attrs: {
            "value": "upload",
            "small": ""
          }
        }, [_c('v-icon', {
          attrs: {
            "left": "",
            "small": ""
          }
        }, [_vm._v("mdi-image-outline")]), _vm._v("\n                                                  Image\n                                                ")], 1), _vm._v(" "), _c('v-btn', {
          attrs: {
            "value": "link",
            "small": ""
          }
        }, [_c('v-icon', {
          attrs: {
            "left": "",
            "small": ""
          }
        }, [_vm._v("mdi-link-variant")]), _vm._v("\n                                                  Link\n                                                ")], 1)], 1) : _vm._e(), _vm._v(" "), (item.refLinkType === 'upload') ? _c('div', {
          staticClass: "reference-upload-dropzone",
          class: {
            'has-file': item.imgName
          }
        }, [_c('v-icon', {
          staticClass: "reference-upload-icon",
          attrs: {
            "color": "secondary"
          }
        }, [_vm._v("\n                                                  " + _vm._s(item.imgName ? 'mdi-check-circle' : 'mdi-cloud-upload-outline') + "\n                                                ")]), _vm._v(" "), _c('div', {
          staticClass: "reference-upload-copy"
        }, [(item.imgName) ? _c('a', {
          attrs: {
            "href": item.imgUrl,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(_vm.getReferenceFileName(item)))]) : _vm._e(), _vm._v(" "), (!item.imgName) ? _c('span', [_vm._v("Upload image")]) : _vm._e(), _vm._v(" "), (_vm.isNotClient) ? _c('small', [_vm._v("Select multiple files to add references at once")]) : _vm._e()]), _vm._v(" "), (_vm.isNotClient) ? _c('direct-file-upload', {
          staticClass: "reference-upload-action",
          attrs: {
            "icon-only": true,
            "multiple": true
          },
          on: {
            "setMedias": function($event) {
              var i = arguments.length, argsArray = Array(i);
              while ( i-- ) argsArray[i] = arguments[i];

              return _vm.uploadFile.apply(void 0, [ deliIndex, boxIdx, imgIdx ].concat( argsArray ))
            }
          }
        }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.refLinkType === 'link') ? _c('v-text-field', {
          staticClass: "purple-input reference-link-field",
          attrs: {
            "dense": "",
            "disabled": _vm.isClient,
            "type": "textbox",
            "outlined": "",
            "required": "",
            "hide-details": "",
            "placeholder": "Paste reference link"
          },
          model: {
            value: (item.link),
            callback: function($$v) {
              _vm.$set(item, "link", $$v)
            },
            expression: "item.link"
          }
        }) : _vm._e()], 1)
      }), _vm._v(" "), (_vm.isNotClient) ? _c('v-btn', {
        staticClass: "reference-add-btn",
        attrs: {
          "small": "",
          "text": ""
        },
        on: {
          "click": function($event) {
            return _vm.addImage(deliIndex, boxIdx)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "left": "",
          "small": ""
        }
      }, [_vm._v("mdi-plus")]), _vm._v("\n                                              Add reference\n                                            ")], 1) : _vm._e()], 2)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
        staticClass: "d-flex flex-row align-center justify-space-between mb-1"
      }, [_c('span', {
        staticClass: "tbl-inner-title"
      }, [_vm._v("BODY")]), _vm._v(" "), _c('div', {
        staticClass: "editor-header-actions"
      }, [(_vm.isNotClient) ? _c('editor-format-info', {
        attrs: {
          "format": _vm.storyboardPlaceholders.bodyInfo
        }
      }) : _vm._e(), _vm._v(" "), _c('v-menu', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (boxItem.showChatBody),
          expression: "boxItem.showChatBody"
        }],
        attrs: {
          "close-on-content-click": false,
          "bottom": "",
          "offset-x": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;
            var attrs = ref.attrs;

            return [(_vm.isCommentSection) ? _c('v-badge', {
              staticStyle: {
                "margin-left": "-10px"
              },
              attrs: {
                "value": boxItem.bodyComments ? boxItem.bodyComments.length : '',
                "content": boxItem.bodyComments ? boxItem.bodyComments.length : '',
                "color": "black",
                "overlap": ""
              },
              on: {
                "click": function($event) {
                  $event.stopPropagation();
                  return _vm.showBodyChatBox(deliIndex, boxIdx)
                }
              }
            }, [(_vm.isCommentSection) ? _c('v-btn', _vm._g(_vm._b({
              staticStyle: {
                "padding": "0",
                "min-width": "34px"
              },
              attrs: {
                "text": ""
              },
              on: {
                "click": function($event) {
                  return _vm.showBodyChatBox(deliIndex, boxIdx)
                }
              }
            }, 'v-btn', attrs, false), on), [_c('v-icon', {
              attrs: {
                "color": "secondary"
              }
            }, [_vm._v("chat")])], 1) : _vm._e()], 1) : _vm._e()]
          }
        }], null, true)
      }, [_vm._v(" "), _c('v-card', {
        staticStyle: {
          "text-align": "left"
        },
        attrs: {
          "max-width": "300"
        }
      }, [_c('v-card-text', {
        staticStyle: {
          "background-color": "#fff",
          "padding": "0"
        }
      }, [_c('chatbox', {
        attrs: {
          "messages": boxItem.bodyComments,
          "title": ""
        },
        on: {
          "sendMessage": function($event) {
            return _vm.sendBodyComment(boxItem.id, $event, 'bodyComments')
          }
        }
      })], 1)], 1)], 1)], 1)]), _vm._v(" "), (_vm.isNotClient) ? _c('sun-editor', {
        staticClass: "body-info-txt",
        attrs: {
          "button-list": _vm.storyboardToolbar,
          "placeholder": _vm.storyboardPlaceholders.bodyInfo,
          "width": "100%",
          "height": "420"
        },
        model: {
          value: (boxItem.bodyInfo),
          callback: function($$v) {
            _vm.$set(boxItem, "bodyInfo", $$v)
          },
          expression: "boxItem.bodyInfo"
        }
      }) : _vm._e(), _vm._v(" "), (_vm.isClient) ? _c('p', {
        staticClass: "cp",
        staticStyle: {
          "min-height": "420px",
          "max-height": "420px",
          "overflow-y": "auto"
        },
        domProps: {
          "innerHTML": _vm._s(_vm.renderHTML(boxItem.bodyInfo))
        }
      }) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('div', {
        staticClass: "text-right mb-1",
        staticStyle: {
          "min-height": "18px"
        }
      }, [_c('div', {
        staticClass: "editor-header-actions"
      }, [(_vm.isNotClient) ? _c('editor-format-info', {
        attrs: {
          "format": _vm.storyboardPlaceholders.briefText
        }
      }) : _vm._e(), _vm._v(" "), _c('v-menu', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (boxItem.showChatBodyTwo),
          expression: "boxItem.showChatBodyTwo"
        }],
        attrs: {
          "close-on-content-click": false,
          "bottom": "",
          "offset-x": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;
            var attrs = ref.attrs;

            return [(_vm.isCommentSection) ? _c('v-badge', {
              staticStyle: {
                "margin-left": "-10px"
              },
              attrs: {
                "value": boxItem.bodyChatTwo ? boxItem.bodyChatTwo.length : '',
                "content": boxItem.bodyChatTwo ? boxItem.bodyChatTwo.length : '',
                "color": "black",
                "overlap": ""
              },
              on: {
                "click": function($event) {
                  $event.stopPropagation();
                  return _vm.showBodyChatBoxTwo(deliIndex, boxIdx)
                }
              }
            }, [(_vm.isCommentSection) ? _c('v-btn', _vm._g(_vm._b({
              staticStyle: {
                "padding": "0",
                "min-width": "34px"
              },
              attrs: {
                "text": ""
              },
              on: {
                "click": function($event) {
                  return _vm.showBodyChatBoxTwo(deliIndex, boxIdx)
                }
              }
            }, 'v-btn', attrs, false), on), [_c('v-icon', {
              attrs: {
                "color": "secondary"
              }
            }, [_vm._v("chat")])], 1) : _vm._e()], 1) : _vm._e()]
          }
        }], null, true)
      }, [_vm._v(" "), _c('v-card', {
        staticStyle: {
          "text-align": "left"
        },
        attrs: {
          "max-width": "300"
        }
      }, [_c('v-card-text', {
        staticStyle: {
          "background-color": "#fff",
          "padding": "0"
        }
      }, [_c('chatbox', {
        attrs: {
          "messages": boxItem.bodyChatTwo,
          "title": ""
        },
        on: {
          "sendMessage": function($event) {
            return _vm.sendBodyCommentTwo(boxItem.id, $event, 'bodyChatTwo')
          }
        }
      })], 1)], 1)], 1)], 1)]), _vm._v(" "), (_vm.isNotClient) ? _c('sun-editor', {
        staticClass: "body-info-txt",
        attrs: {
          "button-list": _vm.storyboardToolbar,
          "placeholder": _vm.storyboardPlaceholders.briefText,
          "width": "100%",
          "height": "420"
        },
        model: {
          value: (boxItem.briefPointer),
          callback: function($$v) {
            _vm.$set(boxItem, "briefPointer", $$v)
          },
          expression: "boxItem.briefPointer"
        }
      }) : _vm._e(), _vm._v(" "), (_vm.isClient) ? _c('div', {
        staticClass: "cp",
        staticStyle: {
          "min-height": "420px",
          "max-height": "420px",
          "overflow-y": "auto",
          "margin-top": "5px"
        },
        domProps: {
          "innerHTML": _vm._s(_vm.renderHTML(boxItem.briefPointer))
        }
      }) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
        attrs: {
          "colspan": "2"
        }
      }, [_c('div', {
        staticClass: "d-flex flex-row align-center justify-space-between mb-1"
      }, [_c('span', {
        staticClass: "tbl-inner-title"
      }, [_vm._v("CTA (input your final CTA scene, not caption)")]), _vm._v(" "), _c('div', {
        staticClass: "editor-header-actions"
      }, [(_vm.isNotClient) ? _c('editor-format-info', {
        attrs: {
          "format": _vm.storyboardPlaceholders.callToAction
        }
      }) : _vm._e(), _vm._v(" "), _c('v-menu', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (boxItem.showChatCta),
          expression: "boxItem.showChatCta"
        }],
        attrs: {
          "close-on-content-click": false,
          "bottom": "",
          "offset-x": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;
            var attrs = ref.attrs;

            return [(_vm.isCommentSection) ? _c('v-badge', {
              staticStyle: {
                "margin-left": "-10px"
              },
              attrs: {
                "value": boxItem.ctaComments ? boxItem.ctaComments.length : '',
                "content": boxItem.ctaComments ? boxItem.ctaComments.length : '',
                "color": "black",
                "overlap": ""
              },
              on: {
                "click": function($event) {
                  $event.stopPropagation();
                  return _vm.showCtaChatBox(deliIndex, boxIdx)
                }
              }
            }, [(_vm.isCommentSection) ? _c('v-btn', _vm._g(_vm._b({
              staticStyle: {
                "padding": "0",
                "min-width": "34px"
              },
              attrs: {
                "text": ""
              },
              on: {
                "click": function($event) {
                  return _vm.showCtaChatBox(deliIndex, boxIdx)
                }
              }
            }, 'v-btn', attrs, false), on), [_c('v-icon', {
              attrs: {
                "color": "secondary"
              }
            }, [_vm._v("chat")])], 1) : _vm._e()], 1) : _vm._e()]
          }
        }], null, true)
      }, [_vm._v(" "), _c('v-card', {
        staticStyle: {
          "text-align": "left"
        },
        attrs: {
          "max-width": "300"
        }
      }, [_c('v-card-text', {
        staticStyle: {
          "background-color": "#fff",
          "padding": "0"
        }
      }, [_c('chatbox', {
        attrs: {
          "messages": boxItem.ctaComments,
          "title": ""
        },
        on: {
          "sendMessage": function($event) {
            return _vm.sendCtaComment(boxItem.id, $event, 'ctaComments')
          }
        }
      })], 1)], 1)], 1)], 1)]), _vm._v(" "), (_vm.isNotClient) ? _c('sun-editor', {
        attrs: {
          "button-list": _vm.storyboardToolbar,
          "placeholder": _vm.storyboardPlaceholders.callToAction,
          "width": "100%",
          "height": "150"
        },
        model: {
          value: (boxItem.callToAction),
          callback: function($$v) {
            _vm.$set(boxItem, "callToAction", $$v)
          },
          expression: "boxItem.callToAction"
        }
      }) : _vm._e(), _vm._v(" "), (_vm.isClient) ? _c('p', {
        staticClass: "cp",
        staticStyle: {
          "min-height": "150px",
          "max-height": "150px",
          "overflow-y": "auto"
        },
        domProps: {
          "innerHTML": _vm._s(_vm.renderHTML(boxItem.callToAction))
        }
      }) : _vm._e()], 1), _vm._v(" "), _c('td', {
        staticClass: "pa-2"
      })])])])])], 1)
    })], 2) : _vm._e(), _vm._v(" "), (deliItem.type === 'igCarousel' || deliItem.type === 'linkedIn') ? _c('div', [_c('v-col', {
      staticClass: "col-xs-12 col-md-12"
    }, [_c('div', {
      staticClass: "d-flex flex-row mb-2"
    }, [_c('span', {
      staticClass: "h4 font-weight-bold mb-2 col-2",
      staticStyle: {
        "min-width": "160px"
      }
    }, [_vm._v("Concept:")]), _vm._v(" "), _c('v-textarea', {
      attrs: {
        "disabled": _vm.isClient,
        "outlined": "",
        "required": "",
        "dense": "",
        "hide-details": "",
        "rows": "5"
      },
      model: {
        value: (deliItem.concept),
        callback: function($$v) {
          _vm.$set(deliItem, "concept", $$v)
        },
        expression: "deliItem.concept"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "d-flex flex-row mb-2"
    }, [_c('span', {
      staticClass: "h4 font-weight-bold mb-2 col-2",
      staticStyle: {
        "min-width": "160px"
      }
    }, [_vm._v("Reason for concept:")]), _vm._v(" "), _c('v-textarea', {
      attrs: {
        "disabled": _vm.isClient,
        "outlined": "",
        "required": "",
        "dense": "",
        "hide-details": "",
        "rows": "5"
      },
      model: {
        value: (deliItem.reasonConcept),
        callback: function($$v) {
          _vm.$set(deliItem, "reasonConcept", $$v)
        },
        expression: "deliItem.reasonConcept"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "d-flex flex-row mb-2"
    }, [_c('span', {
      staticClass: "h4 font-weight-bold mb-2 col-2",
      staticStyle: {
        "min-width": "160px"
      }
    }, [_vm._v("Music choice:")]), _vm._v(" "), _c('v-textarea', {
      attrs: {
        "disabled": _vm.isClient,
        "outlined": "",
        "required": "",
        "dense": "",
        "hide-details": "",
        "rows": "5"
      },
      model: {
        value: (deliItem.musicChoice),
        callback: function($$v) {
          _vm.$set(deliItem, "musicChoice", $$v)
        },
        expression: "deliItem.musicChoice"
      }
    })], 1)]), _vm._v(" "), _vm._l((deliItem.boxes), function(boxItem, boxIdx) {
      return _c('v-col', {
        key: boxIdx,
        staticClass: "col-xs-12 col-md-12"
      }, [_c('table', {
        staticClass: "content-script-table carousel-content-table",
        staticStyle: {
          "border": "none"
        },
        attrs: {
          "dense": ""
        }
      }, [_c('thead', [_c('tr', [_c('th', {
        staticClass: "text-left",
        attrs: {
          "width": "5%"
        }
      }, [_vm._v("\n                                        IMAGE\n                                      ")]), _vm._v(" "), _c('th', {
        staticClass: "text-left",
        attrs: {
          "width": "40%"
        }
      }, [_vm._v("\n                                        Description of image/gif\n                                      ")]), _vm._v(" "), _c('th', {
        staticClass: "text-left",
        attrs: {
          "width": "30%"
        }
      }, [_vm._v("\n                                        Text on image (if any)\n                                      ")]), _vm._v(" "), _c('th', {
        staticClass: "text-left",
        attrs: {
          "width": "20%"
        }
      }, [_vm._v("\n                                        Reference image\n                                      ")]), _vm._v(" "), _c('th', {
        staticClass: "text-left",
        attrs: {
          "width": "5%"
        }
      })])]), _vm._v(" "), _c('tbody', _vm._l((boxItem.images), function(imgRow, imgRowIndex) {
        return _c('tr', {
          key: imgRow.id
        }, [_c('td', {
          staticClass: "text-center"
        }, [_vm._v("\n                                        " + _vm._s(imgRowIndex + 1) + "\n                                      ")]), _vm._v(" "), _c('td', {
          staticClass: "pt-0"
        }, [(_vm.isCommentSection) ? _c('editor-comments', {
          attrs: {
            "messages": imgRow.imgDescriptionComments,
            "title": "Image description"
          },
          on: {
            "sendMessage": function($event) {
              return _vm.sendComment(imgRow.id, $event, 'imgDescriptionComments')
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.isNotClient) ? _c('sun-editor', {
          attrs: {
            "button-list": _vm.storyboardToolbar,
            "placeholder": "",
            "width": "100%",
            "height": "150"
          },
          model: {
            value: (imgRow.imgDescription),
            callback: function($$v) {
              _vm.$set(imgRow, "imgDescription", $$v)
            },
            expression: "imgRow.imgDescription"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.isClient) ? _c('div', {
          staticClass: "cp",
          staticStyle: {
            "min-height": "150px",
            "max-height": "150px",
            "overflow-y": "auto",
            "margin-top": "5px"
          },
          domProps: {
            "innerHTML": _vm._s(_vm.renderHTML(imgRow.imgDescription))
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('td', {
          staticClass: "pt-0"
        }, [(_vm.isCommentSection) ? _c('editor-comments', {
          attrs: {
            "messages": imgRow.textImageComments,
            "title": "Text on image"
          },
          on: {
            "sendMessage": function($event) {
              return _vm.sendComment(imgRow.id, $event, 'textImageComments')
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.isNotClient) ? _c('sun-editor', {
          attrs: {
            "button-list": _vm.storyboardToolbar,
            "placeholder": "",
            "width": "100%",
            "height": "150"
          },
          model: {
            value: (imgRow.textImage),
            callback: function($$v) {
              _vm.$set(imgRow, "textImage", $$v)
            },
            expression: "imgRow.textImage"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.isClient) ? _c('div', {
          staticClass: "cp",
          staticStyle: {
            "min-height": "150px",
            "max-height": "150px",
            "overflow-y": "auto",
            "margin-top": "5px"
          },
          domProps: {
            "innerHTML": _vm._s(_vm.renderHTML(imgRow.textImage))
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('td', {
          staticClass: "pt-0"
        }, [_c('div', {
          staticClass: "reference-upload-card carousel-reference-card"
        }, [(_vm.isNotClient) ? _c('v-btn-toggle', {
          staticClass: "reference-type-toggle",
          attrs: {
            "mandatory": "",
            "dense": ""
          },
          model: {
            value: (imgRow.refLinkType),
            callback: function($$v) {
              _vm.$set(imgRow, "refLinkType", $$v)
            },
            expression: "imgRow.refLinkType"
          }
        }, [_c('v-btn', {
          attrs: {
            "value": "upload",
            "small": ""
          }
        }, [_c('v-icon', {
          attrs: {
            "left": "",
            "small": ""
          }
        }, [_vm._v("mdi-image-outline")]), _vm._v("\n                                              Image\n                                            ")], 1), _vm._v(" "), _c('v-btn', {
          attrs: {
            "value": "link",
            "small": ""
          }
        }, [_c('v-icon', {
          attrs: {
            "left": "",
            "small": ""
          }
        }, [_vm._v("mdi-link-variant")]), _vm._v("\n                                              Link\n                                            ")], 1)], 1) : _vm._e(), _vm._v(" "), (imgRow.refLinkType === 'link') ? _c('v-text-field', {
          staticClass: "purple-input reference-link-field",
          attrs: {
            "dense": "",
            "type": "textbox",
            "outlined": "",
            "required": "",
            "hide-details": "",
            "placeholder": "Paste reference link"
          },
          model: {
            value: (imgRow.link),
            callback: function($$v) {
              _vm.$set(imgRow, "link", $$v)
            },
            expression: "imgRow.link"
          }
        }) : _vm._e(), _vm._v(" "), (imgRow.refLinkType === 'upload') ? _c('div', {
          staticClass: "reference-upload-dropzone",
          class: {
            'has-file': imgRow.imgName
          }
        }, [_c('v-icon', {
          staticClass: "reference-upload-icon",
          attrs: {
            "color": "secondary"
          }
        }, [_vm._v("\n                                              " + _vm._s(imgRow.imgName ? 'mdi-check-circle' : 'mdi-cloud-upload-outline') + "\n                                            ")]), _vm._v(" "), _c('div', {
          staticClass: "reference-upload-copy"
        }, [(imgRow.imgName) ? _c('a', {
          attrs: {
            "href": imgRow.imgUrl,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(_vm.getReferenceFileName(imgRow)))]) : _vm._e(), _vm._v(" "), (!imgRow.imgName) ? _c('span', [_vm._v("Upload image")]) : _vm._e(), _vm._v(" "), (_vm.isNotClient) ? _c('small', [_vm._v("Select multiple files to add rows at once")]) : _vm._e()]), _vm._v(" "), (_vm.isNotClient) ? _c('direct-file-upload', {
          staticClass: "reference-upload-action",
          attrs: {
            "icon-only": true,
            "multiple": true
          },
          on: {
            "setMedias": function($event) {
              var i = arguments.length, argsArray = Array(i);
              while ( i-- ) argsArray[i] = arguments[i];

              return _vm.uploadFile.apply(void 0, [ deliIndex, boxIdx, imgRowIndex ].concat( argsArray ))
            }
          }
        }) : _vm._e()], 1) : _vm._e()], 1)]), _vm._v(" "), _c('td', [(_vm.isNotClient) ? _c('v-btn', {
          attrs: {
            "color": "danger",
            "text": "",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteImage(deliIndex, boxIdx, imgRowIndex)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "red"
          }
        }, [_vm._v("mdi-close-circle")])], 1) : _vm._e()], 1)])
      }), 0)]), _vm._v(" "), (_vm.isNotClient) ? _c('v-btn', {
        staticClass: "reference-add-btn",
        attrs: {
          "small": "",
          "text": ""
        },
        on: {
          "click": function($event) {
            return _vm.addIgCarousel(deliIndex, boxIdx)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "left": "",
          "small": ""
        }
      }, [_vm._v("mdi-plus")]), _vm._v("\n                                Add reference\n                              ")], 1) : _vm._e()], 1)
    })], 2) : _vm._e()], 1)
  })], 2)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticStyle: {
      "margin-right": "15px"
    }
  }, [_c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "12"
    }
  }, [(_vm.isNotClient) ? _c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "disabled": _vm.submitting,
      "x-large": ""
    },
    on: {
      "click": _vm.submitCreatorConcept
    }
  }, [(_vm.submitting) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  }) : _vm._e(), _vm._v("\n                        Submit\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.isClient && !_vm.creatorConceptData.approved) ? _c('v-btn', {
    staticClass: "success",
    attrs: {
      "disabled": _vm.submitting,
      "x-large": ""
    },
    on: {
      "click": _vm.approveCreatorConcept
    }
  }, [(_vm.submitting) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  }) : _vm._e(), _vm._v("\n                        Approve\n                      ")]) : _vm._e()], 1), _vm._v(" "), (_vm.creatorConceptData.versionNo) ? _c('v-col', {
    staticClass: "text-left pl-5",
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.creatorConceptData.versionNo) + ", " + _vm._s(_vm.formatDate(_vm.creatorConceptData.createdAt)) + "\n                    ")]) : _vm._e()], 1)], 1)], 1)])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.imgLoading),
      callback: function($$v) {
        _vm.imgLoading = $$v
      },
      expression: "imgLoading"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_vm._v("\n          Uploading...\n          "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_vm._v("\n          Please stand by\n          "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('version-no-modal', {
    on: {
      "updated": _vm.reload,
      "success": _vm.saveWithVersion
    },
    model: {
      value: (_vm.showVersionDialog),
      callback: function($$v) {
        _vm.showVersionDialog = $$v
      },
      expression: "showVersionDialog"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42f8008e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Pairing/CreatorConceptForm/Form.vue
// module id = 2097
// module chunks = 0